import React from 'react'
import Logo from "../../Reutilizables/Logo"
import Menu from "../../Reutilizables/Menu"
import MenuInicioSuscrito from '../inicioSuscrito/MenuInicioSuscrito'
import Redes from "../../Reutilizables/Redes"
import Footer from '../../Reutilizables/Footer'
import TituloImpuestosMunicipales from "../../Reutilizables/TituloImpuestosMunicipales"
import "../../../styles/quienesSomos/misionyvision.css"

function MisionYVision({ user }) {
  return (
    <>
      <div className='inicon-mision-vision'>
        <div className='container-logo-menu'>
          <Logo />
          
          {
            user ? <MenuInicioSuscrito /> : <Menu />
          }

        </div>
        <TituloImpuestosMunicipales />
        <Redes />
          <div className="container-inicio-mision-vision">

            <section className="section-info-mision">
              <h3> Misión de la empresa</h3>
              <p className='parrafo-section-info-mision'>
                Tributos & Finanzas es una empresa dedicada a orientar y asesorar en el campo tributario y jurídico a entes públicos y 
                privados del país. Ofrecemos soluciones oportunas de acuerdo con las leyes y normas establecidas dentro del territorio 
                nacional, garantizando la calidad y confiabilidad de nuestros servicios. Contribuimos al desarrollo y crecimiento 
                económico de la sociedad, generando valor, progreso y utilidad para la compañía.
              </p>
            </section>

            <section className="section-info2-vision">
              <h3>Visión de la empresa</h3>
              <p className='parrafo-section-info2-vision'>
                Tributos & Finanzas S.A.S será, para el año 2030, una empresa líder a nivel nacional en la capacitación y asesoría
                a entidades territoriales en los temas tributarios, de finanzas y apoyo jurídico."
              </p>
            </section>

            <section className="section-info2-valores">
              <h3>Valores corporativos</h3>
              <h5>1. Ética profesional</h5>
              <p className='parrafo-section-info2-valores'>
                La ética profesional se refiere al conjunto de principios y normas que guían el comportamiento de una persona en el ámbito
                laboral o profesional. Implica actuar con integridad, honestidad y responsabilidad en todas las decisiones y acciones 
                relacionadas con el trabajo.
              </p>
              <h5>2. Respeto</h5>
              <p className='parrafo-section-info2-valores'>
                El respeto implica tratar a los demás con consideración, dignidad y cortesía, reconociendo sus derechos y opiniones. 
                Se trata de valorar la diversidad y tratar a las personas con empatía y sin discriminación.
              </p>
              <h5>3. Compromiso</h5>
              <p className='parrafo-section-info2-valores'>
                El compromiso se relaciona con la dedicación y la responsabilidad hacia las tareas y metas que se han asumido. 
                Implica estar dispuesto a esforzarse y trabajar con diligencia para alcanzar los objetivos, incluso en situaciones desafiantes.
              </p>
              <h5>4. Cooperación y Ayuda  Mutua</h5>
              <p className='parrafo-section-info2-valores'>
                La cooperación involucra trabajar en conjunto con otros para lograr objetivos comunes, compartiendo ideas, recursos y esfuerzos.
                La ayuda mutua implica estar dispuesto a brindar apoyo y asistencia a los demás en momentos de necesidad, creando un 
                ambiente de colaboración y solidaridad.
              </p>
              <h5>5. Sentido Social</h5>
              <p className='parrafo-section-info2-valores'>
                El sentido social se refiere a la conciencia y responsabilidad que se tiene hacia la comunidad y la sociedad en general. 
                Implica considerar el impacto de las acciones en el bienestar de otros y en la construcción de una sociedad más justa y 
                equitativa.
              </p>
              <h5>6. Responsabilidad</h5>
              <p className='parrafo-section-info2-valores'>
                La responsabilidad se trata de cumplir con los deberes y obligaciones de manera diligente y consciente. 
                Implica asumir las consecuencias de las propias acciones y decisiones, tanto en el ámbito personal como en el profesional, 
                y actuar de manera ética y cuidadosa.
              </p>
            </section>
            
          </div>
        <Footer />
      </div>
    </>
  )
}

export default MisionYVision